export const BALANCES = {
    MAIN_BALANCE: 'PNRNg7fkXUvn1bJdrTGF',
    EXTERNAL_BALANCE: 'X07JqaEEOCuFYgqOVJBs',
    TAX_BALANCE: '0haQVkIjykDBCwBf35pv',
};
